<template>
  <div>
    <v-btn
      class="activator"
      v-on:click="toggleDrawer()"
      color="white"
      v-if="!drawer"
    >
      <v-icon color="primary" class="mr-2">mdi-account-box-multiple</v-icon>
      {{ $t(`${this.resource}.${this.resource}`) }}
    </v-btn>
    <v-navigation-drawer
      class="navigation"
      v-model="drawer"
      fixed
      :style="{
        transform:
          'translateX(' +
          (($vuetify.application.left === 256 ? 100 : 0) - (drawer ? 0 : 100)) +
          '%)',
        paddingTop: $vuetify.application.top + 'px'
      }"
      ref="root"
      disable-route-watcher
    >
      <v-list-item>
        <v-text-field
          :label="$t(`${this.resource}.search-label`)"
          clearable
          v-model="search"
          append-icon="mdi-magnify"
        ></v-text-field>
      </v-list-item>
      <v-list dense class="navigation-results">
        <template v-if="!isLoading">
          <v-list-item
            v-for="item in filteredList"
            v-bind:key="item.id"
            :to="generateLink(item)"
            :class="{
              'v-list-item--active': isCurrentItem(item)
            }"
            exact
          >
            <v-list-item-title class="pr-10 list-title">
              {{ item.name }}
              <v-btn
                class="list-title-pencil"
                :to="{
                  name: routeNameForEdit,
                  params: {
                    id: item.id
                  }
                }"
                depressed
                absolute
                right
                icon
                small
                v-if="
                  routeNameForEdit && hasPermissions(item, permissionsForUpdate)
                "
              >
                <v-icon small color="primary">mdi-pencil</v-icon>
              </v-btn>
            </v-list-item-title>
          </v-list-item>
        </template>
        <template v-else>
          <v-skeleton-loader
            ref="skeleton"
            type="list-item"
            class="mx-auto"
            v-for="index in 5"
            :key="'skeleton' + index"
          ></v-skeleton-loader>
        </template>
      </v-list>
      <slot name="footer"></slot>
    </v-navigation-drawer>
  </div>
</template>
<script>
import { permissions } from "../../mixins/permissions";
export default {
  name: "PrimaryNavigation",
  mixins: [permissions],
  props: {
    resource: {
      type: String
    },
    listGetter: {
      type: String
    },
    listDispatch: {
      type: String
    },
    nameItemInQuery: {
      type: String,
      default: "id"
    },
    routeNameForItems: {
      type: String
    },
    routeNameForEdit: {
      type: String
    },
    permissionsForUpdate: {
      type: String
    },
    routeMode: {
      type: String,
      validator: function(value) {
        return ["params", "query"].indexOf(value) !== -1;
      },
      default: "query"
    },
    staticRouteQuery: {
      type: Object,
      default: function() {
        return {};
      }
    },
    dispatchParams: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data: function() {
    return {
      timerId: null,
      search: "",
      isLoading: false,
      nameNewAddressBook: "",
      filter: "",
      drawer: true
    };
  },
  computed: {
    list: {
      get() {
        return this.$store.getters[this.listGetter] || [];
      }
    },
    filteredList() {
      if (this.search) {
        return this.list.filter(
          i => i.name.toUpperCase().indexOf(this.search.toUpperCase()) > -1
        );
      } else {
        return this.list;
      }
    }
  },

  methods: {
    toggleDrawer() {
      this.drawer = !this.drawer;
    },
    isCurrentItem(item) {
      return this.$route[this.routeMode][this.nameItemInQuery] === item.id;
    },
    updateList() {
      this.isLoading = true;
      this.$store.dispatch(this.listDispatch, {
        params: {
          limit: -1,
          ...this.dispatchParams
        },
        onSuccess: () => {
          this.isLoading = false;
        }
      });
    },
    generateLink(item) {
      let to = {
        name: this.routeNameForItems,
        query: {
          ...this.$route.query,
          ...this.staticRouteQuery
        },
        params: {
          ...this.$route.params
        }
      };
      to[this.routeMode][this.nameItemInQuery] = this.isCurrentItem(item)
        ? ""
        : item.id;
      return to;
    }
  },
  mounted() {
    this.updateList();
  }
};
</script>

<style lang="scss" scoped>
.navigation-results {
  height: calc(100% - 70px);
  overflow-y: auto;
}
.list-title {
  word-break: break-word;
  font-weight: 400 !important;
  .list-title-pencil {
    top: 50%;
    transform: translateY(-50%);
  }
}
.activator {
  z-index: 2;
  position: fixed;
  top: 48px;
  left: 0;
  background: #fff;
}
.navigation {
  z-index: 3 !important;
}
</style>
